<template>
  <div class="activity-detail">
    <div class="activity-info-title">
      <h3 style="margin-right: 10px">{{ $route.name }}</h3>
      <el-button @click="beBack" type="primary" plain>返回</el-button>
      <el-button @click="exportData" type="primary" plain>导出</el-button>
    </div>
    <h3>活动信息</h3>
    <el-row class="activity-info">
      <el-col :span="12">
        <span class="activity-name">活动名称</span>
        <span>{{ form.name }}</span>
      </el-col>
      <el-col :span="12">
        <span class="activity-name">活动类型</span>
        <span>{{ form.activityType }}</span>
      </el-col>
      <el-col :span="24">
        <span class="activity-name">活动时间</span>
        <span>{{ form.startTime }}至{{ form.endTime }}</span>
      </el-col>
      <el-col :span="12">
        <span class="activity-name">适用渠道</span>
        <span>{{ form.channelType }}</span>
      </el-col>
      <el-col :span="12">
        <span class="activity-name">适用用户</span>
        <span>{{ form.userChannel }}</span>
      </el-col>
      <el-col :span="12">
        <span class="activity-name">适用商品</span>
        <span>{{ form.participationType }}</span>
      </el-col>
      <el-col :span="12">
        <span class="activity-name">适用门店</span>
        <span>{{ form.openStore }}</span>
      </el-col>
      <div v-if="form.openStore=='指定门店'" class="someStores">
        <SimpleTable :tableStyleName='"dialogTable"' :tableDataTitle='storeColumns' :tableDataP='tableDataStore'
        ></SimpleTable>
      </div>
    </el-row>
    <el-divider></el-divider>
    <h3>活动效果</h3>
    <div class="activity-money">
      <el-tag>线上</el-tag>
      <div style="margin-left:20px">活动成交金额:{{ form.onlineAmountReceived == null ? 0 : form.onlineAmountReceived }}</div>
      <div style="margin:0 150px">活动折让金额:{{ form.onlineDiscountPrice == null ? 0 : form.onlineDiscountPrice }}</div>
      <div>成交单数:{{ form.onlineOrderCount == null ? 0 : form.onlineOrderCount }}</div>
    </div>
    <div class="activity-money">
      <el-tag>线下</el-tag>
      <div style="margin-left:20px">活动成交金额:{{ form.amountReceived == null ? 0 : form.amountReceived }}</div>
      <div style="margin:0 150px">活动折让金额:{{ form.discountPrice == null ? 0 : form.discountPrice }}</div>
      <div>成交单数:{{ form.orderCount == null ? 0 : form.orderCount }}</div>
    </div>
    <search-form-template
      ref="activity"
      :searchOptions="activitySearchOptions"
      class="activity-search"
      @clear="searchClear"
      @searchSubmit="searchSubmit"
    ></search-form-template>
    <SimpleTable
      style="margin-top:10px;margin-bottom:30px"
      :tableStyleName='"dialogTable"'
      :tableDataTitle='detailTableOptions'
      :tableDataP='form.mkActivityMVOPage.records'
      :showPagination="showPagination"
      :pageTotal="pageTotal"
      @page-change="pageChange"
    >
    </SimpleTable>
  </div>
</template>

<script>
import api from "@/config/api";
import userPower from "@/mixin/userPower";
import SimpleTable from '@/components/template/simpleTable'

export default {
  mixins: [userPower],
  components: {SimpleTable},
  data() {
    return {
      pageTotal: 0,
      showPagination: true,
      tableData: [],
      tableDataStore: [],
      page: {
        current: 1,
        total: 0,
        pageSize: 10
      },
      searchParam: {},
      form: {
        name: '',
        activityType: null,
        startTime: '',
        endTime: '',
        channelType: '',//适用渠道
        userChannel: '',//适用用户
        participationType: '',//参与商品
        openStore: null,//适用门店
        storeIds: '',//指定门店id
        onlineAmountReceived: '',//线上实收
        amountReceived: '',//线下实收
        onlineDiscountPrice: '',// 线上优惠
        discountPrice: '',// 线下优惠
        onlineOrderCount: '',// 线上单数
        orderCount: '',// 线下单数
        mkActivityMVOPage: {
          records: []
        },
      },
      storeColumns: [
        {
          label: '门店编号',
          prop: 'serialNumber'
        },
        {
          label: '门店名称',
          prop: 'storyName'
        },
        {
          label: '门店类型',
          prop: 'storesType'
        },
      ],
      activitySearchOptions: {
        simple: [
          {
            label: '',
            prop: 'orderNo',
            type: 'input',
            span: 8,
            placeholder: '请输入单号'
          },
        ],
        complex: [
          {
            label: '',
            prop: 'CreateDttm',
            type: 'datetimeRange',
            dateType: 'datetime',
            placeholder: '活动时间',
            span: 12
          },
          {
            label: "",
            prop: "activityType",
            type: "select",
            placeholder: '活动类型',
            span: 12,
            data: [{name: '全部', value: ''}, {name: '线上', value: '10'}, {name: '线下', value: '20'}],
          },
        ],
      },
      // 活动详情列表
      detailTableOptions: [
        {label: '序号', prop: 'index', width: '60'},
        {
          label: '单号',
          prop: 'orderNo',
        },
        {
          label: '会员手机号',
          prop: 'memberPhone',
        },
        {
          label: '参与渠道',
          prop: 'typeName',
        },
        {
          label: '活动商品支付金额',
          prop: 'amountReceived',
        }
        ,
        {
          label: '折扣金额',
          prop: 'discountPrice',
        }
        ,
        {
          label: '支付时间',
          prop: 'lastModifyDttm',
        }
        ,
      ],
    }
      ;
  },
  created() {
  },
  mounted() {
    this.getTableData()
    this.getStore()
  },
  methods: {
    //返回按钮事件
    beBack() {
      this.$router.go(-1);
    },
    // 指定门店
    getStore() {
      let params = []
      if (this.form.storeIds && this.form.storeIds.indexOf(',') != 0) {
        params = this.form.storeIds.split(',')
      } else {
        params = []
      }
      if (params.length > 0) {
        this.$axios.fetchPost(api.store.store + '/list', {ids: params})
          .then(res => {
            if (res.code == 200) {
              this.tableDataStore = res.data.ids
            }
          })
      }
    },
    // 搜索重置
    searchClear() {
      this.searchParam = {};
      this.getTableData();
    },
    //搜索查询
    searchSubmit(param) {
      this.searchParam = param
      this.getTableData()
    },
    // 类型转化
    shiftType(val, type) {
      switch (type) {
        case 'activityType':
          if (val == 10) {
            val = '限时特价'
          }
          if (val == 20) {
            val = '限时折扣'
          }
          if (val == 30) {
            val = '满减活动'
          }
          if (val == 40) {
            val = '满减折扣'
          }
          break;
        case 'channelType':
          if (val == 10) {
            val = '线上'
          }
          if (val == 20) {
            val = '线下'
          }
          if (val == 30) {
            val = '全部'
          }
          break;
        case 'userChannel':
          if (val == 10) {
            val = '全部'
          }
          if (val == 20) {
            val = '普通用户'
          }
          if (val == 30) {
            val = '会员'
          }
          break;
        case 'openStore':
          if (!val) {
            val = '全部'
          } else {
            val = '指定门店'
          }
          break;
        case 'participationType':
          if (val == 10) {
            val = '全部'
          }
          if (val == 20) {
            val = '指定分类'
          }
          if (val == 30) {
            val = '指定商品'
          }
          break;
        default:
          break;
      }
      return val
    },
    // 下一页
    pageChange(page, size) {
      this.page.current = page
      this.page.pageSize = size
      this.getTableData()
    },
    // 详情列表数据
    getTableData() {
      let defaultParam = {
        activityId: this.$route.query.activityId,
        pageNumber: this.page.current,
        pageSize: this.page.pageSize
      }
      let params = {...this.searchParam, ...defaultParam}
      this.$axios.fetchPost(api.promotion.activityDetail, params)
        .then(res => {
          if (res.code == 200) {
            if (res.data) {
              this.form = res.data
              this.pageTotal = res.data.mkActivityMVOPage.total
              this.form.activityType = this.shiftType(res.data.activityType, 'activityType')
              this.form.channelType = this.shiftType(res.data.channelType, 'channelType')
              this.form.userChannel = this.shiftType(res.data.userChannel, 'userChannel')
              this.form.openStore = this.shiftType(res.data.openStore, 'openStore')
              this.form.participationType = this.shiftType(res.data.participationType, 'participationType')
            }
          } else {
            this.$message({
              type: "error",
              message: '请求错误' + res.code
            })
          }

        })
    },
    exportData() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let defaultParam = {
        activityId: this.$route.query.activityId,
      };
      let param = {...this.searchParam, ...defaultParam};
      this.$axios.PostBlob(api.promotion.activityDetailExport, param).then(res => {
        if (res.status === 200) {
          const fileName = '活动详情_' + this.form.name + '_' + this.$utils.getDateTime() + ".xlsx";
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.$message.success("导出成功,文件名称:" + fileName);
        } else {
          this.$message.error("导出失败,请稍后再试");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    }
  },
};
</script>

<style scoped>
.activity-detail {
  background: #fff;
  border-radius: 8px;
  padding: 0 25px;
}

.activity-info-title {
  background-color: #fff;
  align-items: center;
  margin-bottom: 10px;
  border-bottom: 3px solid #d8d8d8;
  white-space: nowrap;
  overflow-y: hidden;
  padding: 5px 0;
  display: flex;
  /*justify-content: space-between;*/
}

.activity-info {
  padding: 10px 10px 0 10px;
}

.activity-name {
  display: inline-block;
  width: 80px;
  font-size: 14px;
  line-height: 30px;
}

.activity-money {
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;
  background-color: #f5f5f5;
  font-size: 16px;
  margin: 10px 0;
  padding: 0 10px;
}

.el-divider--horizontal {
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/page/activity/detail.vue